import type Echo from 'laravel-echo';
import { createContext, useContext } from 'react';

export interface EchoContextValue {
    echo: Echo<'reverb'> | null;
    /** Logged-in user id, or null when anonymous. */
    userId: number | null;
}

export const EchoContext = createContext<EchoContextValue>({ echo: null, userId: null });

export function useEcho(): EchoContextValue {
    return useContext(EchoContext);
}
